import React, { useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import DriverInfoShared from "./driverInfoShared";
import "primeicons/primeicons.css";
import { withTranslation } from "react-i18next";
import DriversWrapper from "./drivers.styles";

const data = [
  {
    title: "Other Information",
  },
];

const Drivers = ({ i18n }) => {
  const currentLanguageCode = i18n.language || "en";
  const showRTL = currentLanguageCode === "ar";
  const [accordian, toggleAccordian] = useState(false);

  const handleAccordian = (bool) => {
    toggleAccordian(bool);
  };
  return (
    <DriversWrapper>
      <Accordion
        onTabOpen={() => handleAccordian(true)}
        onTabClose={() => handleAccordian(false)}
      >
        <AccordionTab
          header={
            <React.Fragment>
              <div className="row">
                <div
                  className={
                    !showRTL ? "col-10 headerText" : "col-10 headerText-rtl"
                  }
                >
                  Drivers
                </div>
                <div
                  className={!showRTL ? "col-2 IconDiv" : "col-2 IconDiv-rtl"}
                >
                  {accordian ? (
                    <i className="pi pi-chevron-up accordianIcon"></i>
                  ) : (
                    <i className="pi pi-chevron-down accordianIcon"></i>
                  )}
                </div>
              </div>
            </React.Fragment>
          }
        >
          <DriverInfoShared />
        </AccordionTab>
      </Accordion>
    </DriversWrapper>
  );
};

export default withTranslation()(Drivers);
